
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import GET_JOB_TITLES from "@/apollo/autocomplete-queries/GetJobTitles.gql";
  import DropdownOption from "@/entities/DropdownOption";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      jobTitles: {
        query: GET_JOB_TITLES,
        variables() {
          return {
            jobTitleSearchString: `%${this.jobTitleSearchString}%`, 
            limit: 10,
          };
        },
        update(data) {
          return data.user_job_title.map((jobTitle: any) => ({
            id: jobTitle.id,
            name: jobTitle.job_title
          }));
        },
        skip() {
          return !this.jobTitleSearchString;
        },
      },
    },
  })

  export default class JobTitleMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;
    @Prop({ type: String, default: "Job Title" }) readonly placeholder: string;

    jobTitles: DropdownOption[] = [];
    jobTitleSearchString = "";

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val)
    }
  }
